// product-form-new.js
export default (Alpine) => {
    Alpine.data("dynamicBundle", (
        stackParentId,
        stackParentTitle,
        stackDiscountValue,
        stackDiscountType,
        stackParentVariantId
    ) => ({
        stackParentId: Number(stackParentId),
        stackParentTitle: stackParentTitle,
        stackDiscountValue: Number(stackDiscountValue),
        stackDiscountType: stackDiscountType,
        stackParentVariantId: Number(stackParentVariantId),
        bundleObj: window.dynamicBundle,
        currentVariant: null,
	    sellingPlan: '',
        sellingPlanName: 'Select Frequency',
	    deliveryOptions: false,
		quantity: 1,
		purchaseOption: 'Subscribe & Save',
        totalOriginalPrice: 0,
        totalOtpPrice: 0,
        totalSubPrice: 0,
        stackProducts: [],
        dynamicBox: {},
        dynamicBoxId: '',
        available: true,
        tierDiscount: {
            "1": 0,
            "2": 10,
            "3": 15,
            "4": 20,
            "5": 25,
        },
        jsLoaded: false,
        buttonText: 'SELECT FREQUENCY',

        get stackDiscount() {
            return this.tierDiscount[this.stackProducts.length];
        },

        get totalDiscount() {
            return this.totalPrice * (1 - this.stackDiscount / 100);
        },

        get totalPrice() {
            return this.stackProducts.reduce((acc, product) => acc + Number(this.bundleObj[product].price), 0);
        },

        async init() {
            this.jsLoaded = true;
            const purchaseOptions = this.$el.querySelectorAll('[data-purchase-option]');

            purchaseOptions.forEach(option => {
                const input = option.querySelector('input[type="radio"]');
                input.addEventListener('change', this.purchaseOptionChange.bind(this));
            });


            const frequencyOptions = this.$el.querySelector('.frequencyOptions');
            frequencyOptions.addEventListener('change', this.frequencyChange.bind(this));

            document.addEventListener('add-to-cart', this.addToCart.bind(this));

            const checkedPurchase = this.$el.querySelector('[data-purchase-option] input[type="radio"]:checked');
			const deliveryOptions = this.$el.querySelector('.deliveryOptions');
			if (checkedPurchase?.value) {
			  this.purchaseOption = checkedPurchase.value;
			} else {
			  this.purchaseOption = (this.currentVariant?.selling_plan_allocations > 0 && !this.isMerch)
				? 'Subscribe & Save'
				: 'One-time Purchase';
			}

			if (this.purchaseOption === 'Subscribe & Save') {
				const freqSelector = this.$el.querySelector('.frequency-select');
				this.sellingPlan = freqSelector?.dataset?.value || this.sellingPlan || '';
				this.sellingPlanName = freqSelector?.dataset?.name || this.sellingPlanName || 'Select Frequency';
				deliveryOptions.classList.add('open');
			} else {
				this.sellingPlan = '';
				this.sellingPlanName = 'Select Frequency';
				deliveryOptions.classList.remove('open');
			}



            Array.from(this.$el.querySelectorAll('[data-option]')).forEach(option => {
                
                let value = ''
                if (option.querySelector('[data-option-select]')) {
                    value = option.querySelector('[data-option-button]').dataset.selectedVariantId;
                } else if (option.querySelector('input[type="hidden"]')) {
                    value = option.querySelector('input[type="hidden"]').value;
                } else {
                    this.available = false;
                }

                const optionIndex = option.dataset.option;
                this.stackProducts[optionIndex] = value;
            });

            if (this.available) {
                this.updatePrices(false);
            } else {
                this.updatePrices(true);
            }


            this.setButtonText();
            await this.fetchDynamicBox();
            this.updatePrices(false);
        },

        toggle() {
			if (this.open) {
				setTimeout(() => {
					return this.close()
				}, 100);
			}

			this.$refs.button.focus()

			this.open = true
		},

		close(focusAfter) {
			if (! this.open) return

			setTimeout(() => {
				this.open = false
			}, 100);

			focusAfter && focusAfter.focus()
		},

		onKeyDown(event) {
			const options = Array.from(this.$refs.panel.querySelectorAll('[role="option"]'));
			const current = event.currentTarget;
			const index = options.indexOf(current);
			const next = options[index + 1] || options[0]; // wrap to first
			next.focus();
		  },
		  
		  onKeyUp(event) {
			const options = Array.from(this.$refs.panel.querySelectorAll('[role="option"]'));
			const current = event.currentTarget;
			const index = options.indexOf(current);
			const prev = options[index - 1] || options[options.length - 1]; // wrap to last
			prev.focus();
		  },

		  openAndFocusOption() {
			if (!this.open) {
			  this.open = true;
			}
		  
			this.$nextTick(() => {
			  const selected =
				this.$refs.panel.querySelector('[aria-selected="true"]') ||
				this.$refs.panel.querySelector('[role="option"]');
		  
			  if (selected) {
				selected.focus();
			  }
			});
		},

    
        async fetchDynamicBox() {
            await fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': '*/*'
                },
                    body: JSON.stringify({
                    productPlatformId: this.stackParentId
                })
            })
                .then(res => res.json())
                .then(data => {
                    this.dynamicBox = data.DynamicBox;
                    this.dynamicBoxId = this.dynamicBox.boxId;
                })
                .catch(err => console.error("Dynamic Box Error:", err));
        },

        changeVariant(productId, event) {

            const target = event?.target;
            const index = target.closest('[data-option]').dataset.option;
            const selectedIndex = target.selectedIndex;
            this.stackProducts[index] = target.dataset.variantId;
            const variantId = Number(target.dataset.variantId);
            this.selectedVariantId = variantId;

            const selectDropdown = target.closest('[data-select-dropdown]');
            if (selectDropdown) {
                selectDropdown.dataset.flavor = target.options[selectedIndex].dataset.flavor;
                selectDropdown.value = variantId
            }

            this.updatePrices(false);

            const variantImage = target?.dataset.variantImage;
            const variantImageEl = target?.closest('[data-option]').querySelector('[data-variant-image-container]');

            if (!variantImageEl) return;

            if (variantImage) {
                variantImageEl.src = variantImage;
            }

            if (target.hasAttribute('data-flavor')) {
                const flavorSelect = target;
                flavorSelect.dataset.flavor = target.options[selectedIndex].dataset.flavor;
            }

            const option = target?.closest('[data-option]');

            const productTitle = option.querySelector('[data-product-title]');
            productTitle.innerHTML = this.bundleObj[variantId].productTitle;

            const button = option?.querySelector('[data-option-button]');
            const flavorIcon = button.querySelector('[data-variant-flavor-icon]');

            button.dataset.selectedVariantId = String(variantId);

            if (target.hasAttribute('data-flavor-image')) {
                flavorIcon.classList.remove('hidden');
            } else {
                flavorIcon.classList.add('hidden');
            }
            flavorIcon.dataset.flavor = this.bundleObj[variantId].title.split(' / ')[0];
            button.querySelector('[data-variant-title]').innerHTML = this.bundleObj[variantId].productTitle;
            
            this.open = false;

            // Select Accessible Label
            const selectLabel = document.querySelectorAll('.variant-options .select-label');
            selectLabel.forEach((label) => {
                const selectDropdown = label.closest('div').querySelector('.select-select');
                const attrName = selectDropdown?.getAttribute('name');
                if (attrName === 'select-option0') {
                    label.setAttribute('for', variantId);
                    selectDropdown.setAttribute('id', variantId);
                }
            });
        },

      

        updatePrices(defaultPrices = false) {
            if (defaultPrices) {
                const originalPrice = this.$el.querySelector('[data-original-price]');
                const subPrice = this.$el.querySelector('[data-sub-price]');
                const otpPrice = this.$el.querySelector('[data-otp-price]');
                this.totalOriginalPrice = originalPrice.innerHTML;
                this.totalOtpPrice = otpPrice.innerHTML;
                this.totalSubPrice = subPrice.innerHTML;
                return;
            }

            let totalPrice = 0;
            let subPrice = 0;
            let newPrice = 0;
            let selectedSellingPlan = null;

            this.stackProducts.forEach(variantId => {
                console.log('bundle obj', this.bundleObj[variantId]?.price);
                totalPrice += Number(this.bundleObj[variantId]?.price || 0);
            });

            console.log('stack discount', this.stackDiscount);



            const totalPriceCents = totalPrice;

            const newPriceCents = Math.ceil(
              totalPriceCents * (100 - this.stackDiscount) / 100
            );
            
            totalPrice = totalPriceCents / 100;
            newPrice = newPriceCents / 100;

            if (this.sellingPlan) {
                selectedSellingPlan = this.sellingPlan;
                this.sellingPlanName = this.sellingPlanName;
            } else {
                selectedSellingPlan = Object.keys(window.sellingPlanGroups)[0];
                this.sellingPlanName = window.sellingPlanGroups[selectedSellingPlan].name;
            }

            const subDiscount = window.sellingPlanGroups[selectedSellingPlan].discount_value;
            const subDiscountType = window.sellingPlanGroups[selectedSellingPlan].discount_type;


            if (subDiscountType === 'percentage') {
                subPrice = newPrice * (1 - subDiscount / 100);
            } else {
                subPrice = newPrice - subDiscount;
            }

            this.totalOriginalPrice = this.formatMoney(totalPrice);
            this.totalOtpPrice = this.formatMoney(newPrice);
            this.totalSubPrice = this.formatMoney(subPrice);
        },

        formatMoney(value, fmt = window.Shopify?.money_format || "{{amount}}") {
            const toCents = (v) => {
              if (typeof v === 'number') return Math.round(v * 100);
              if (typeof v === 'string') {
                const cleaned = v.trim().replace(/[,$\s]/g, '');
                const n = Number(cleaned);
                return Number.isFinite(n) ? Math.round(n * 100) : 0;
              }
              return 0;
            };
    
            const cents = toCents(value);
    
            if (window.Shopify?.formatMoney) {
              return window.Shopify.formatMoney(cents, fmt);
            }
    
            const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            const token = (fmt.match(placeholderRegex) || [, 'amount'])[1];
    
            const withDelims = (n, precision = 2, thousands = ',', decimal = '.') => {
              if (n == null || isNaN(n)) return '0';
              const s = (n / 100).toFixed(precision);
              const [intPart, frac] = s.split('.');
              const intWithSep = intPart.replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
              return precision ? `${intWithSep}${decimal}${frac}` : intWithSep;
            };
    
            let rendered;
            switch (token) {
              case 'amount':
                rendered = withDelims(cents, 2);
                break;
              case 'amount_no_decimals':
                rendered = withDelims(cents, 0);
                break;
              case 'amount_with_comma_separator':
                rendered = withDelims(cents, 2, '.', ',');
                break;
              case 'amount_no_decimals_with_comma_separator':
                rendered = withDelims(cents, 0, '.', ',');
                break;
              default:
                rendered = withDelims(cents, 2);
            }
    
            return fmt.replace(placeholderRegex, rendered);
        },

        purchaseOptionChange(e) {
            const freqSelector = this.$el.querySelector('.frequency-select');

            if (e.target.value === 'Subscribe & Save') {
                this.sellingPlan = freqSelector?.value
                this.sellingPlanName = window.sellingPlanGroups[this.sellingPlan]?.name
                this.toggleDeliveryOptions();
                this.purchaseOption = 'Subscribe & Save';
            } else {
                this.sellingPlan = '';
                this.sellingPlanName = 'Select Frequency';
                this.toggleDeliveryOptions();
                this.purchaseOption = 'One-time Purchase';
            }

            this.setButtonText();
        },

        toggleDeliveryOptions() {
                const deliveryOptions = this.$el.querySelector('.deliveryOptions');
                deliveryOptions.classList.toggle('open');
        },

        setButtonText() {
            const addToCartButton = this.$refs.addToCartButton;

            if (!addToCartButton) return;

            if (this.available) {            
                if (this.purchaseOption === 'Subscribe & Save' && this.sellingPlan === '') {
                    addToCartButton.disabled = true;
                    this.buttonText = 'SELECT FREQUENCY';
                } else {
                    addToCartButton.disabled = false;
                    this.buttonText = 'ADD TO CART';
                }
            } else {
                this.buttonText = 'SOLD OUT';
                addToCartButton.disabled = true;

            }
        },

        frequencyChange(e) {
            this.sellingPlan = e.target.dataset.value;
            this.sellingPlanName = window.sellingPlanGroups[this.sellingPlan]?.name;
            this.setButtonText();
            this.open = false;
        },

        async getBundleIndex() {
            const res = await fetch('/cart.js');
            const cartData = await res.json();
          
            const indices = cartData.items
              .map(item => Number(item.properties?._dynamicBoxIndex))
              .filter(val => !isNaN(val));
          
            const largestIndex = indices.length > 0 ? Math.max(...indices) : -1;
            const bundleIndex = largestIndex + 1;
          
            return bundleIndex;
        },

        generateUniqueHash(length = 32) {
            const randomPart = Array.from(crypto.getRandomValues(new Uint8Array(length)))
              .map(b => b.toString(16).padStart(2, '0'))
              .join('');
            const timePart = Date.now().toString(16);
            return `${timePart}${randomPart}`;
        },

        async addToCart() {
            const sideCart = document.querySelector('side-cart');
            const items = [];
            const bundleIndex = await this.getBundleIndex();
            const bundleSessionId = this.generateUniqueHash();

            this.stackProducts.forEach(variantId => {
                items.push({
                    id: variantId,
                    quantity: 1,
                    selling_plan: this.sellingPlan ? Number(this.sellingPlan) : null,
                    properties: {
                        _attribution: 'Skio Dynamic Product Bundle',
                        _attribution_stack: 'Skio Stack',
                        _dynamicBoxIndex: bundleIndex,
                        _dynamicBoxId: this.dynamicBoxId,
                        _bundleSellingPlanId: Number(this.sellingPlan),
                        _stackParentId: this.stackParentId,
                        _stackParentTitle: this.stackParentTitle,
                        _is_stack: true,
                        _bundle_session_id: bundleSessionId,
                        _internal_id: this.dynamicBoxId,
                        _is_stack_child: true
                    }
                });
            });

            items.push({
                id: this.stackParentVariantId,
                selling_plan: this.sellingPlan ? Number(this.sellingPlan) : null,
                quantity: 1,
                properties: {
                    _attribution: 'Skio Dynamic Product Bundle',
                    _attribution_stack: 'Skio Stack',
                    _bundleSellingPlanId: Number(this.sellingPlan),
                    _stackParentId: this.stackParentId,
                    _stackParentTitle: this.stackParentTitle,
                    _is_stack: true,
                    _bundle_session_id: bundleSessionId,
                    _internal_id: this.dynamicBoxId,
                    _is_stack_parent: true
                }
            })


            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    items: items,
                }),
            })
            .then(response => response.json())
            .then(data => {
                Rebuy.SmartCart.show()
            })
            .catch(error => {
                console.error('Error:', error);
            });
        },

				
    }));
  };